import { Link } from "react-router-dom";

const CallToPage = ({ address, text, bGColor, hoverBgColor }) => {
  return (
    <button
      className={`flex items-center h-full justify-center ${bGColor} hover:${hoverBgColor} text-white text-sm rounded-md`}
    >
      <Link className="w-full h-full px-4 flex items-center" to={`/${address}`}>
        {text}
      </Link>
    </button>
  );
};

export default CallToPage;
